import { ActionTypes } from "../../constants/ActionTypes";
import { EditorState } from "draft-js";

export const onChangeDraftEditor = (payload: EditorState) => {
    return {
        type: ActionTypes.CHANGE_EDITOR_DRAFT,
        payload: payload,
    };
};
